"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCNGrid = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var collectionsRef_1 = require("common/db/collectionsRef");
var budgetLinesList_1 = require("common/global/budgetLinesList");
var projectsList_1 = require("common/global/projectsList");
var unitsList_1 = require("common/global/unitsList");
var usersList_1 = require("common/global/usersList");
var emptyCell_1 = require("portal/components/Grid/helpers/emptyCell");
var getDateForCell_1 = __importDefault(require("portal/utils/getDateForCell"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Grid_1 = require("../../../components/Grid/Grid");
var titleCell_1 = require("../../../components/Grid/helpers/titleCell");
var valueByMode_1 = require("../../../components/Grid/helpers/valueByMode");
var header_1 = require("../../../components/header");
var index_modules_css_1 = __importDefault(require("../../../index.modules.css"));
var OrderHeader_1 = __importDefault(require("../components/OrderHeader"));
var IRGrid_1 = require("../IR/IRGrid");
var donorsList_1 = require("common/global/donorsList");
var valueCell_1 = require("portal/components/Grid/helpers/valueCell");
function SCNGrid(_a) {
    var _b, _c, _d, _e;
    var state = _a.state, mode = _a.mode, dispatch = _a.dispatch;
    // const hasSignature = globalProjectsData[state.SCNData.projectId].hasSignature ?? false
    var hasSignature = false;
    var t = (0, react_i18next_1.useTranslation)().t;
    //   const projectCode = globalProjectsData[state.SCNData.projectId]?.code;
    var projectsCodes = state.SCNData.projectsIds
        .map(function (projectId) { var _a; return (_a = projectsList_1.globalProjectsData[projectId !== null && projectId !== void 0 ? projectId : ""]) === null || _a === void 0 ? void 0 : _a.code; })
        .join(", ");
    var budgetLine = (_b = budgetLinesList_1.globalBudgetLinesData[state.SCNData.budgetLineId]) === null || _b === void 0 ? void 0 : _b.code;
    var SCNheader = [
        [
            (0, titleCell_1.TitleCell)({ title: t("scn.scnNumber"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.SCNData.SCNNumber,
                inputType: "text",
                path: "",
                colSpan: 4,
            }),
            (0, titleCell_1.TitleCell)({ title: t("scn.projectCode"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: projectsCodes,
                inputType: "text",
                path: "",
                colSpan: 4,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("scn.scnDate"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: mode === "view"
                    ? t("common.date", {
                        date: (0, getDateForCell_1.default)(state === null || state === void 0 ? void 0 : state.SCNData.date, mode),
                    })
                    : (0, getDateForCell_1.default)(state === null || state === void 0 ? void 0 : state.POData.PODate, mode),
                //   moment(state?.POData.PODate),
                inputType: "datePicker",
                path: "SCNData.date",
                colSpan: 10,
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            // TitleCell({ title: t('scn.budgetLine'), colSpan: 2 }),
            // ValueByMode({ mode, value: budgetLine, inputType: 'text', path: 'e', colSpan: 4 }),
        ],
    ];
    var SCNbody = [
        [
            (0, titleCell_1.TitleCell)({ title: "Service Contract No", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.SCNData.contractNo,
                inputType: "textInput",
                path: "SCNData.contractNo",
                colSpan: 10,
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: "Service Location ", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.SCNData.deliveryLocation,
                inputType: "textInput",
                path: "SCNData.deliveryLocation",
                colSpan: 10,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: "Supplier Name", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "".concat(state.SCNData.supplierName),
                colSpan: 4,
                inputType: "text",
                path: "SCNData.supplierName",
            }),
            (0, titleCell_1.TitleCell)({ title: t("scn.consigneeName"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_c = state.SCNData.consigneName) !== null && _c !== void 0 ? _c : "",
                colSpan: 4,
                inputType: "text",
                path: "SCNData.consigneName",
                // required: state.triedSubmitting,
                // triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: "Address", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "".concat(state.SCNData.supplierAddress),
                colSpan: 4,
                inputType: "text",
                path: "SCNData.supplierName",
            }),
            (0, titleCell_1.TitleCell)({ title: "Address", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "Independent Doctors Association (Bağımsız Doktorlar Derneği)",
                colSpan: 4,
                inputType: "text",
                path: "SCNData.consigneName",
                // required: state.triedSubmitting,
                // triedSubmitting: state.triedSubmitting,
            }),
        ],
    ];
    var itemsHeader = [
        [
            (0, titleCell_1.TitleCell)({ title: t("scn.itemNo"), colSpan: 1, textAlign: "center" }),
            (0, titleCell_1.TitleCell)({ title: "Budget Line", colSpan: 1, textAlign: "center" }),
            (0, titleCell_1.TitleCell)({
                title: t("scn.description"),
                colSpan: 4,
                textAlign: "center",
            }),
            (0, titleCell_1.TitleCell)({
                title: "Received Service Description(Condition)",
                colSpan: 1,
                textAlign: "center",
            }),
            (0, titleCell_1.TitleCell)({ title: t("scn.unit"), colSpan: 1, textAlign: "center" }),
            (0, titleCell_1.TitleCell)({
                title: t("scn.servisOrdered"),
                colSpan: 2,
                textAlign: "center",
            }),
            (0, titleCell_1.TitleCell)({
                title: t("scn.servisReceived"),
                colSpan: 1,
                textAlign: "center",
            }),
            (0, titleCell_1.TitleCell)({ title: t("scn.remarks"), colSpan: 1, textAlign: "center" }),
        ],
    ];
    var items = state.SCNItems.map(function (item, idx) {
        var _a, _b, _c;
        var budgetLines = item.budgetLinesIds
            .map(function (budgetLineId) { var _a; return (_a = budgetLinesList_1.globalBudgetLinesData[budgetLineId !== null && budgetLineId !== void 0 ? budgetLineId : ""]) === null || _a === void 0 ? void 0 : _a.code; })
            .join(", ");
        var unit = (_b = (_a = unitsList_1.globalUnitsData[item.unitId]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "";
        var budgetLineId = item.budgetLineId
            ? budgetLinesList_1.globalBudgetLinesData[item.budgetLineId].code
            : "";
        return [
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: idx + 1 + "", colSpan: 1, inputType: "text" }),
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: budgetLines, colSpan: 1, inputType: "text" }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "".concat((_c = item === null || item === void 0 ? void 0 : item.productName) !== null && _c !== void 0 ? _c : "", " -").concat(item === null || item === void 0 ? void 0 : item.productDescription),
                colSpan: 4,
                inputType: "text",
            }),
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: "", colSpan: 1, inputType: "text" }),
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: unit, colSpan: 1, inputType: "text" }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: item.serviceOrdered,
                colSpan: 2,
                inputType: "text",
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: item.serviceReceived,
                colSpan: 1,
                inputType: "textInput",
                path: "SCNItems[".concat(idx, "].serviceReceived"),
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: item.remarks,
                colSpan: 1,
                inputType: "textInput",
                path: "SCNItems[".concat(idx, "].remarks"),
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ];
    });
    var approvalCell = function (approvalType, requiredApprovalType) {
        var _a, _b;
        var approval = (_a = state.approvalsData) === null || _a === void 0 ? void 0 : _a.find(function (e) {
            return e.approvalType === approvalType;
        });
        var requiredApproval = (_b = state.approvalsData) === null || _b === void 0 ? void 0 : _b.find(function (e) {
            return e.approvalType === requiredApprovalType;
        });
        if (approval) {
            return (0, valueByMode_1.ValueByMode)({
                mode: "view",
                value: "",
                colSpan: 2,
                rowSpan: 2,
            });
        }
        else if ((requiredApproval &&
            state.SCNData.status !== "approved" &&
            state.SCNData.status !== "cancelled" &&
            state.SCNData.status !== "completed" &&
            state.SCNData.status !== "draft" &&
            state.SCNData.status !== "singedAndArchived") ||
            (!requiredApprovalType &&
                state.SCNData.status !== "approved" &&
                state.SCNData.status !== "cancelled" &&
                state.SCNData.status !== "completed" &&
                state.SCNData.status !== "draft" &&
                state.SCNData.status !== "singedAndArchived")) {
            return {
                action: "Approve",
                // payload: approvalType,
                payload: {
                    approvedAt: state.approvedAtSignatureDate.toDate(),
                    approvalType: approvalType,
                },
                text: t("cba.approve"),
                confirmMessage: t("alerts.areYouSureYouWantToApproveThisDocument"),
                confirmAction: true,
                type: "button",
                colSpan: 2,
                rowSpan: 2,
            };
        }
        else {
            return (0, emptyCell_1.emptyCell)({
                colSpan: 2,
                rowSpan: 2,
            });
        }
    };
    //   function approvals(state: SCNState, t) {
    //     const getApproval = (approvalType: string) => {
    //       const approval = state.approvalsData?.find((e) => {
    //         return e.approvalType === approvalType;
    //       });
    //       return approval;
    //     };
    //     const approvingDate = (approvalType: string) => {
    //       const approval2 = getApproval(approvalType);
    //       const date = approval2?.approvedAt;
    //       return t("common.date", { date: date?.toDate() });
    //     };
    //     const approvingSig = (approvalType: string) => {
    //       const approval2 = getApproval(approvalType);
    //       const sig = approval2?.signatureURL;
    //       return sig;
    //     };
    //     return [
    //       [
    //         TitleCell({
    //           title: t("dn.receivedAndCheckedBy"),
    //           colSpan: 6,
    //           rowSpan: 1,
    //         }),
    //         TitleCell({ title: t("dn.approvedBy"), colSpan: 6, rowSpan: 1 }),
    //       ],
    //       [
    //         TitleCell({ title: t("dn.name"), colSpan: 2, rowSpan: 1 }),
    //         TitleCell({ title: t("dn.sign"), colSpan: 2, rowSpan: 1 }),
    //         TitleCell({ title: t("dn.date"), colSpan: 2, rowSpan: 1 }),
    //         TitleCell({ title: t("dn.name"), colSpan: 2, rowSpan: 1 }),
    //         TitleCell({ title: t("dn.sign"), colSpan: 2, rowSpan: 1 }),
    //         TitleCell({ title: t("dn.date"), colSpan: 2, rowSpan: 1 }),
    //       ],
    //       [
    //         approvalCell("receivedAndCheckedBy"),
    //         ValueCell({
    //           value: " ",
    //           img: hasSignature && approvingSig("receivedAndCheckedBy"),
    //           colSpan: 2,
    //           rowSpan: 2,
    //         }),
    //         ValueCell({
    //           value: approvingDate("receivedAndCheckedBy"),
    //           colSpan: 2,
    //           rowSpan: 2,
    //         }),
    //         approvalCell("approvedBy", "receivedAndCheckedBy"),
    //         ValueCell({
    //           value: " ",
    //           img: hasSignature && approvingSig("approvedBy"),
    //           colSpan: 2,
    //           rowSpan: 2,
    //         }),
    //         ValueCell({
    //           value: approvingDate("approvedBy"),
    //           colSpan: 2,
    //           rowSpan: 2,
    //         }),
    //       ],
    //       [],
    //     ];
    //   }
    //   const SCNfooter = [
    //     [
    //       TitleCell({
    //         title: t("scn.deliveredBy"),
    //         colSpan: 12,
    //         textAlign: "center",
    //       }),
    //     ],
    //     [
    //       TitleCell({
    //         title: t("scn.nameTitleAndSignature"),
    //         colSpan: 12,
    //         textAlign: "center",
    //       }),
    //     ],
    //     [emptyCell({ colSpan: 12, rowSpan: 2 })],
    //     [],
    //     [
    //       TitleCell({
    //         title:
    //           "IMPORTANT: 1. All actual and potential conflicts of interests must be disclosed to Independent Doctors Association directly to the employee’s supervisor or to Human Resources whenever a conflict arises. By signing this document Independent Doctors Association staff attests:- they or their immediate family members have no personal relationship with listed vendors or their employees, - no interest or financial gain or any other type of Conflict of Interest related to this procurement- to have not been employed by any of the vendors from solicitation previously.   2. Concerning that,  all tax responsibility that may be raised is the supplier’s liability.",
    //         colSpan: 12,
    //         backgroundColor: "#fff",
    //       }),
    //     ],
    //   ];
    var donorId = (_d = projectsList_1.globalProjectsData[state.SCNData.projectId]) === null || _d === void 0 ? void 0 : _d.donorId;
    var miLogo = __assign(__assign({}, header_1.baseCell), { type: "image", src: (_e = donorsList_1.globalDonorsData[donorId]) === null || _e === void 0 ? void 0 : _e.logo, height: 50, colSpan: 4, textAlign: "center" });
    var getApproval = function (approvalType) {
        var _a;
        var approval = (_a = state.approvalsData) === null || _a === void 0 ? void 0 : _a.find(function (e) {
            return e.approvalType === approvalType;
        });
        return approval;
    };
    var approvingDate = function (approvalType) {
        var approval2 = getApproval(approvalType);
        var date = approval2 === null || approval2 === void 0 ? void 0 : approval2.approvedAt;
        return t("common.date", { date: date === null || date === void 0 ? void 0 : date.toDate() });
    };
    var approvingSig = function (approvalType) {
        var approval2 = getApproval(approvalType);
        var sig = approval2 === null || approval2 === void 0 ? void 0 : approval2.signatureURL;
        return sig;
    };
    var approvingUser = function (approvalType) {
        var approval2 = getApproval(approvalType);
        var uid = approval2 === null || approval2 === void 0 ? void 0 : approval2.userId;
        return uid;
    };
    var sigMode = function (type) {
        var _a;
        var approval = (_a = state === null || state === void 0 ? void 0 : state.approvalsData) === null || _a === void 0 ? void 0 : _a.find(function (approval) { return approval.approvalType == type; });
        var newMode = mode == "edit" ? "view" : approval ? "view" : "edit";
        return newMode;
    };
    var receivedAndCheckedByTitle = approvingUser("receivedAndCheckedBy")
        ? usersList_1.globalUsersData[approvingUser("receivedAndCheckedBy")].jobTitle
        : "";
    var approvedByTitle = approvingUser("approvedBy")
        ? usersList_1.globalUsersData[approvingUser("approvedBy")].jobTitle
        : "";
    var gridData = {
        data: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
            (0, IRGrid_1.logoHeader)({
                idaLogo: miLogo,
                title: t("scn.serviceCompleteNoteScn"),
                colSpan: 4,
            })
        ], SCNheader, true), SCNbody, true), itemsHeader, true), items, true), [
            [
                (0, titleCell_1.TitleCell)({
                    title: t("dn.receivedAndCheckedBy"),
                    colSpan: 3,
                    rowSpan: 3,
                }),
                (0, titleCell_1.TitleCell)({ title: "Date", colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: "Name", colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: "Title", colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: "Signature", colSpan: 3, rowSpan: 1 }),
            ],
        ], false), [
            [
                // ValueCell({
                //   value: approvingDate("receivedAndCheckedBy") ?? "",
                //   colSpan: 2,
                //   rowSpan: 2,
                // }),
                (0, valueByMode_1.ValueByMode)({
                    mode: sigMode("receivedAndCheckedBy"),
                    value: sigMode("receivedAndCheckedBy") === "view"
                        ? approvingDate("receivedAndCheckedBy")
                        : state.approvedAtSignatureDate,
                    inputType: "datePicker",
                    path: "approvedAtSignatureDate",
                    required: state.triedSubmitting,
                    triedSubmitting: state.triedSubmitting,
                    colSpan: 2,
                    rowSpan: 2,
                }),
                approvalCell("receivedAndCheckedBy"),
                (0, valueCell_1.ValueCell)({ value: "", colSpan: 2, rowSpan: 2 }),
                (0, valueCell_1.ValueCell)({
                    value: " ",
                    img: hasSignature && approvingSig("receivedAndCheckedBy"),
                    colSpan: 3,
                    rowSpan: 2,
                }),
            ],
            []
        ], false), [
            [
                (0, titleCell_1.TitleCell)({ title: t("dn.approvedBy"), colSpan: 3, rowSpan: 3 }),
                (0, titleCell_1.TitleCell)({ title: "Date", colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: "Name", colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: "Title", colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: "Signature", colSpan: 3, rowSpan: 1 }),
            ],
        ], false), [
            [
                // ValueCell({
                //   value: approvingDate("approvedBy") ?? "",
                //   colSpan: 2,
                //   rowSpan: 2,
                // }),
                getApproval("receivedAndCheckedBy")
                    ? (0, valueByMode_1.ValueByMode)({
                        mode: sigMode("approvedBy"),
                        value: sigMode("approvedBy") === "view"
                            ? approvingDate("approvedBy")
                            : state.approvedAtSignatureDate,
                        inputType: "datePicker",
                        path: "approvedAtSignatureDate",
                        required: state.triedSubmitting,
                        triedSubmitting: state.triedSubmitting,
                        colSpan: 2,
                        rowSpan: 2,
                    })
                    : (0, emptyCell_1.emptyCell)({ colSpan: 2, rowSpan: 2 }),
                approvalCell("approvedBy", "receivedAndCheckedBy"),
                (0, valueCell_1.ValueCell)({ value: "", colSpan: 2, rowSpan: 2 }),
                (0, valueCell_1.ValueCell)({
                    value: " ",
                    img: hasSignature && approvingSig("approvedBy"),
                    colSpan: 3,
                    rowSpan: 2,
                }),
            ],
            []
        ], false), [
            [
                (0, titleCell_1.TitleCell)({ title: t("dn.deliveredBy"), colSpan: 3, rowSpan: 3 }),
                (0, titleCell_1.TitleCell)({ title: "Date", colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: "Name", colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: "Title", colSpan: 2, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: "Signature", colSpan: 3, rowSpan: 1 }),
            ],
        ], false), [
            [
                (0, valueCell_1.ValueCell)({ value: "", colSpan: 2, rowSpan: 2 }),
                (0, valueCell_1.ValueCell)({ value: "", colSpan: 2, rowSpan: 2 }),
                (0, valueCell_1.ValueCell)({ value: "", colSpan: 2, rowSpan: 2 }),
                (0, valueCell_1.ValueCell)({ value: "", colSpan: 3, rowSpan: 2 }),
            ],
            [],
        ], false),
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: index_modules_css_1.default.gridBox }, { children: [(0, jsx_runtime_1.jsx)(OrderHeader_1.default, { state: __assign({}, state.SCNData), dispatch: dispatch, type: "SCN", orderRef: collectionsRef_1.SCNsRef.doc(state.SCNId) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(Grid_1.ExcelLikeGrid, { onButtonClicked: function (action, payload) {
                        dispatch({
                            type: "buttonClick",
                            data: {
                                action: action,
                                payload: payload,
                            },
                        });
                    }, onValueUpdate: function (path, newValue) {
                        dispatch({
                            type: "update",
                            payload: {
                                path: path,
                                newValue: newValue,
                            },
                        });
                    }, grid: gridData }) })] })));
}
exports.SCNGrid = SCNGrid;
exports.default = SCNGrid;
